import { routePaths } from "@/App";
import { Button } from "@/components/ui/button";
import { useUser } from "@/libs/auth/data/user";
import { isInsideCapacitorBrowser } from "@/libs/auth/utils/tokens";
import { getLogger } from "@/utils/logger";
import { Browser } from "@capacitor/browser";

import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";

const log = getLogger("app:loginpage");

export function LoginPage() {
  const navigate = useNavigate();

  const { isInitialized, isLoggedIn, handleKeycloakRedirect, login } =
    useUser();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (isInitialized && isLoggedIn) {
      navigate(routePaths.home);
      return;
    }
  }, [isInitialized, isLoggedIn, navigate]);

  useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");

    if (!code || !state) {
      return;
    }

    Browser.close();

    if (isInsideCapacitorBrowser()) {
      log("Error: Attempted login inside the Capacitor In-App Browser.");
      return;
    }

    handleKeycloakRedirect();
  }, [handleKeycloakRedirect, searchParams]);

  return (
    <div className="min-h-screen bg-slate-100 pt-[16rem] max-w-xl mx-auto">
      <img
        src="/images/logo.png"
        alt="logo"
        className="w-[7.5rem] mx-auto mb-8 object-cover"
      />

      <header className="text-center space-y-2 mx-2">
        <h3 className="text-3xl font-semibold">Willkommen zur Fahrer App</h3>
        <p className="text-slate-500">Bitte logge dich ein, um fortzufahren</p>
      </header>

      <div className="bg-white p-4 w-full fixed bottom-0 max-w-xl mx-auto pb-safe border-t-2 border-neutral">
        <Button onClick={login} className="w-full">
          Anmelden
        </Button>
      </div>
    </div>
  );
}
